<div autofocus class="search-contents">
    <mat-form-field>
        <mat-select placeholder="{{'historyTexts.type' | translate}}" [(ngModel)]="displayOptions.isLogin">
            <mat-option [value]="0" (click)="resetLoginOptions()">
                <!-- ALL -->
                {{'historyTexts.all' | translate}}
            </mat-option>
            <mat-option [value]="true" (click)="setSignOptions('LOGIN')">
                {{'historyTexts.loginSignings' | translate}}
            </mat-option>
            <mat-option [value]="false" (click)="setSignOptions('DOCUMENT')">
                {{'historyTexts.document' | translate}}
            </mat-option>
            <mat-option [value]="false" (click)="setSignOptions('BATCH_SIGNING')">
                {{'historyTexts.packageDocuments' | translate}}
            </mat-option>
            <mat-option [value]="false" (click)="setSignOptions('REGISTERED_DELIVERY')">
                {{'historyTexts.registeredMail' | translate}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-select placeholder="{{'historyTexts.orderStatusDocument' | translate}}" [(ngModel)]="selectValue"
            [disabled]="isStatusDisabled()" (selectionChange)="setOrderStatusSingle($event.value)">
            <mat-option *ngFor="let s of statusLablesDocument" [value]="s">
                {{getDocumentStatusText(s)}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-select placeholder="{{'historyTexts.orderStatusPackageRegisteredMail' | translate}}"
            matTooltip="{{'historyTexts.orderStatusPackageRegisteredMail' | translate}}" [(ngModel)]="selectMultipleValue"
            [disabled]="isMultipleStatusDisabled()"
            (selectionChange)="setOrderStatusMultiple($event.value)">
            <mat-option *ngFor="let s of statusLablesMultiple" [value]="s">
                {{getPackageStatusText(s)}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <input matInput [matDatepicker]="startDate" placeholder="{{'historyTexts.startDate' | translate}}"
            [(ngModel)]="fromDate" (ngModelChange)="setRequestDates()" [max]="maxStartDateValue">
        <mat-datepicker-toggle matSuffix [for]="startDate">
            <cqes-icon icon="calendar_today" class="calendar-icon">
            </cqes-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
         <button *ngIf="fromDate" class="close-button" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearFromDate()">
            <cqes-icon icon="close">
            </cqes-icon>
        </button>
    </mat-form-field>

    <mat-form-field>
        <input matInput [matDatepicker]="endDate" placeholder="{{'historyTexts.endDate' | translate}}"
            [(ngModel)]="toDate" (ngModelChange)="setRequestDates()" [min]="minEndDateValue">
        <mat-datepicker-toggle matSuffix [for]="endDate">
            <cqes-icon icon="calendar_today" class="calendar-icon">
            </cqes-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
        <button *ngIf="toDate" class="close-button" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearToDate()">
            <cqes-icon icon="close">
            </cqes-icon>
        </button>
    </mat-form-field>
    <br>

    <mat-form-field class="search-container">
        <input class="search-input" matInput placeholder="{{'historyTexts.name' | translate}}"
            [(ngModel)]="displayOptions.textToShow" (keydown.enter)="searchDocument()">
        <button *ngIf="displayOptions.textToShow" class="close-button" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearText()">
            <cqes-icon icon="close">
            </cqes-icon>
        </button>
    </mat-form-field>

    <mat-form-field class="search-container">
        <input class="search-input" matInput placeholder="{{'historyTexts.sender' | translate}}"
            [(ngModel)]="displayOptions.sender" (keydown.enter)="searchDocument()">
        <button *ngIf="displayOptions.sender" class="close-button" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearTextSender()">
            <cqes-icon icon="close">
            </cqes-icon>
        </button>
    </mat-form-field>

<div class="action-buttons">
    <button class="mat-mdc-raised-button" (click)="searchDocument()">
        {{'historyTexts.searchIntoSignDocs'
        | translate}}
    </button>

    <button class="mat-mdc-raised-button" (click)="resetFilters()">
        {{'historyTexts.resetFilters' | translate}}
    </button>
</div>
    
</div>

<div class="message" *ngIf="!hasData() && loaded">
    {{'historyTexts.noDocumentsFound' | translate}}
</div>

<div class="data-container" [hidden]="!hasData()">
    <div class="message" *ngIf="isOverLimit()">
        {{'historyTexts.first500Docs' | translate}}
    </div>

    <div class="mat-elevation-z8 table-content">
        <mat-table [dataSource]="signingHistoryDataSource" matSort matSortActive="date" matSortDirection="desc">
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>
                    {{'historyTexts.documentStatus' | translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row"
                    matTooltip="{{(row.statusIcon)?.tooltip | translate}}">
                    <cqes-icon [icon]="row.statusIcon.icon" [iconClass]="row.statusIcon.colorClass"></cqes-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
                <mat-header-cell #date *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(date)">
                    {{'historyTexts.createDate' | translate}}
                </mat-header-cell>
                <mat-cell  *matCellDef="let row">
                    {{row.date | date: dateFormat}}<br>{{row.date | date: timeFormat}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="signedDate">
                <mat-header-cell #signedDate  *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(signedDate)">
                    {{'historyTexts.signedDate' | translate}}
                </mat-header-cell>
                <mat-cell  *matCellDef="let row">
                    {{row.signedDate | date: dateFormat}}<br>{{row.signedDate | date: timeFormat}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="objectType">
                <mat-header-cell #objectType  *matHeaderCellDef>
                    {{'historyTexts.objectType' | translate}}
                </mat-header-cell>
                <mat-cell  *matCellDef="let row">
                    {{getTypeHeader(row.contentTypeId)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="objectName">
                <mat-header-cell #objectName  *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(objectName)">
                    {{'historyTexts.objectName' | translate}}
                </mat-header-cell>
                <mat-cell  #el *matCellDef="let row" class="truncate" [matTooltip]="(el.scrollWidth > el.clientWidth) ? row.name : ''">
                    {{row.name}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="senderName">
                <mat-header-cell #senderName
                    *matHeaderCellDef mat-sort-header (click)="sortByHeader(senderName)">
                    {{'historyTexts.senderName' | translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    {{getSenderName(row)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="documentsCount">
                <mat-header-cell #documentsCount  *matHeaderCellDef mat-sort-header (click)="sortByHeader(documentsCount)">
                    {{'businessTexts.documentsCount'
                    | translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.documentCount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell #downloadDocument  *matHeaderCellDef>
                    {{'historyTexts.actions' | translate}}</mat-header-cell>
                <mat-cell  *matCellDef="let row">
                    <div>
                        <span [matMenuTriggerFor]="actionsMenu">
                            <button mat-icon-button color="primary" *ngIf="checkActions(row)">
                                <cqes-icon icon="menu"></cqes-icon>
                            </button>
                        </span>
                        <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay menu">
                            <!-- Details -->
                            <button mat-menu-item color="primary" matTooltip="{{'businessTexts.details' | translate}}" *ngIf="checkMultipleDocumentsDetails(row)"
                                (click)="openDetailsDialog(row)">
                                <cqes-icon icon="info_outline"></cqes-icon>
                                {{'businessTexts.details' | translate}}
                            </button>
                            <!-- Downloads For type document -->
                            <div *ngIf="checkSingleDocument(row)">
                                <button mat-menu-item *ngIf="checkForDownload(row)"
                                    matTooltip="{{'historyTexts.downloadDocument' | translate}}"
                                    (click)="onDownloadCert(row)">
                                    <cqes-icon icon="file_download"></cqes-icon>
                                    {{'historyTexts.downloadDoc' | translate}}
                                </button>
                                <button mat-menu-item *ngIf="checkRequestedForDownload(row)"
                                    matTooltip="{{'historyTexts.downloadRequestedDocument' | translate}}"
                                    (click)="onDownloadRequestedCert(row)">
                                    <cqes-icon icon="file_download"></cqes-icon>
                                    {{'historyTexts.downloadRequestedDocument' | translate}}
                                </button>
                                <button mat-menu-item color="primary" *ngIf="checkForDownload(row) && isArhived(row)"
                                    matTooltip="{{'historyTexts.downloadSimpleReport' | translate}}"
                                    (click)="onDownloadReport(row, 'SIMPLE')">
                                    <cqes-icon icon="playlist_add_check"></cqes-icon>
                                    {{'historyTexts.downloadEvedenceRecSimple' | translate}}
                                </button>
                                <button mat-menu-item color="primary" *ngIf="checkForDownload(row) && isArhived(row)"
                                    matTooltip="{{'historyTexts.downloadDetailedReport' | translate}}"
                                    (click)="onDownloadReport(row, 'DETAILED')">
                                    <cqes-icon icon="playlist_add"></cqes-icon>
                                    {{'historyTexts.downloadEvedenceRecExtend' | translate}}
                                </button>
                            </div>
                            <!-- Download for package/registered mail -->
                            <button *ngIf="checkMultipleDocuments(row)"mat-menu-item matTooltip="{{getDownloadHeader(row.contentTypeId)}}"  
                                    (click)="onDownloadMultiple(row)">
                                    <cqes-icon icon="file_download"></cqes-icon>
                                    {{getDownloadHeader(row.contentTypeId)}} 
                                </button>
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [pageSize]="tableHelper.pageSize" [pageSizeOptions]="tableHelper.pageSizeOptions"
            (page)="onPaginateChange($event)">
        </mat-paginator>
    </div>
</div>